import { Outlet, useLoaderData } from '@remix-run/react';

import type { loader } from './loader';

export { loader } from './loader';

export default function Card() {
	const data = useLoaderData<typeof loader>();
	return <Outlet context={data} />;
}
